import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchWrapper } from "../_helpers";

// create slice

const name = "changepassword";
const initialState = createInitialState();
const reducers = createReducers();
const extraActions = createExtraActions();
const extraReducers = (builder) => {
  createExtraReducers(builder);
};
const slice = createSlice({ name, initialState, reducers, extraReducers });

// exports
export const changepasswordActions = { ...slice.actions, ...extraActions };
export const changepasswordReducer = slice.reducer;

// implementation

function createInitialState() {
  return {
    error: null,
    changepasswordResponse: [],
    savePasscodeResponse: [],
    getAdminPasscodeResponse: "",
  };
}
function createReducers() {
  return {
    clearChangeResponse,
  };
  function clearChangeResponse(state) {
    state.changepasswordResponse = [];
  }
}
function createExtraActions() {
  const baseUrl = `${process.env.REACT_APP_API_URL}/ChangePassword`;
  const baseUrlUser = `${process.env.REACT_APP_API_URL}/User`;
  return {
    savechangepassword: savechangepassword(),
    savePasscode: savePasscode(),
    GetAdminPasscode: GetAdminPasscode(),
  };
  function savechangepassword() {
    return createAsyncThunk(
      `${name}/savechangepassword`,
      async (addFormData) =>
        await fetchWrapper.post(`${baseUrl}/SaveChangePassword`, addFormData)
    );
  }
  function GetAdminPasscode() {
    return createAsyncThunk(
      `${name}/GetAdminPasscode`,
      async (userId) =>
        await fetchWrapper.get(
          `${baseUrlUser}/GetAdminPasscode?UserID=${userId}`
        )
    );
  }

  function savePasscode() {
    return createAsyncThunk(
      `${name}/savePasscode`,
      async (addFormData) =>
        await fetchWrapper.post(`${baseUrlUser}/SaveAdminPasscode`, addFormData)
    );
  }
}

function createExtraReducers(builder) {
  builder
    //savechangepassword
    .addCase(extraActions.savechangepassword.pending, (state) => {
      state.changepasswordResponse = { loading: true };
    })
    .addCase(extraActions.savechangepassword.fulfilled, (state, action) => {
      state.changepasswordResponse = action.payload;
    })
    .addCase(extraActions.savechangepassword.rejected, (state, action) => {
      state.changepasswordResponse = { error: action.error };
    })
    //savePasscode
    .addCase(extraActions.savePasscode.pending, (state) => {
      state.savePasscodeResponse = { loading: true };
    })
    .addCase(extraActions.savePasscode.fulfilled, (state, action) => {
      state.savePasscodeResponse = action.payload;
    })
    .addCase(extraActions.savePasscode.rejected, (state, action) => {
      state.savePasscodeResponse = { error: action.error };
    })
    //GetAdminPasscode
    .addCase(extraActions.GetAdminPasscode.pending, (state) => {
      state.getAdminPasscodeResponse = { loading: true };
    })
    .addCase(extraActions.GetAdminPasscode.fulfilled, (state, action) => {
      state.getAdminPasscodeResponse = action.payload;
    })
    .addCase(extraActions.GetAdminPasscode.rejected, (state, action) => {
      state.getAdminPasscodeResponse = { error: action.error };
    });
}
